// extracted by mini-css-extract-plugin
module.exports = {"parallax":"Parallax__parallax__8iipk","parallaxText":"Parallax__parallaxText__pmEPe"};